export const VAL_MOBILE_INVALID = 1
export const VAL_PASSWD_INVALID = 2
export const VAL_PASSWD_INVALID_CHAR = 3
export const VAL_CODE_WRONG = 4

export const VAL_COMMON_WRONG = 1000
export const VAL_OK = 0

export function checkMobile(locale: string, mobile: string): number {
  // console.log('checkPhone', locale, mobile)
  // throw new Error("CheckMobile");
  // if (locale == 'zh_CN') {
  const re = /^1[1,2,3,4,5,6,7,8,9][0-9]{9}$/
  const result = re.test(mobile)
  if (!result) {
    return VAL_MOBILE_INVALID
    // return false //若手机号码格式不正确则返回false
  }
  // }
  return VAL_OK
}

export function checkPassword(password: string): number {
  const re = /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d~@#$%_\-=\.]{6,20}$/
  const result = re.test(password)
  console.log('result', result)
  if (!result) {
    const regex = /[^A-Za-z\d~@#$%_\-=\.]/
    const hasInvalidChars = regex.test(password)
    console.log('hasInvalidChars', hasInvalidChars)
    if (hasInvalidChars) {
      console.log('hasInvalidChars：notice')
      return VAL_PASSWD_INVALID_CHAR
    } else {
      console.log('passwdInvalid：notice')
      return VAL_PASSWD_INVALID
    }
  }
  return VAL_OK
}

export function checkCode(locale: string, code: string): number {
  console.log('checkCode', locale, code)
  const re = /^(?=.*\d).{6}$/
  const result = re.test(code)
  if (!result) {
    // return false
    return VAL_CODE_WRONG
  }
  return VAL_OK
}
